import { Component, HostListener, inject, ChangeDetectionStrategy } from '@angular/core';
import { RktButtonDirective } from '@rocketfinancialcorp/rocket-ui/button';
import { ActiveModal } from '@rocketfinancialcorp/rocket-ui/modal';
import { AttentionModalComponent } from '@shared/components';
import { BusinessAccountService, NotificationService } from '@shared/services';
import { finalize, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-reset-service-account-confirm-modal',
  templateUrl: './reset-service-account-confirm-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AttentionModalComponent, RktButtonDirective],
})
export class ResetServiceAccountConfirmModalComponent {
  activeModal = inject(ActiveModal);

  businessAccountService = inject(BusinessAccountService);

  notificationService = inject(NotificationService);

  serviceAccountId!: string;

  loading = false;

  private destroy$ = new Subject<void>();

  @HostListener('document:keydown.enter')
  onEnterPress() {
    this.resetServiceAccount();
  }

  resetServiceAccount(): void {
    this.loading = true;
    this.businessAccountService
      .resetServiceAccount(this.serviceAccountId)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => (this.loading = false)),
      )
      .subscribe({
        next: (response) => {
          this.activeModal.close(response);
        },
        error: () => {
          this.notificationService.displayError('Unable to reset Service Account please try again.');
          this.activeModal.close();
        },
      });
  }
}
